<template>
  <div class="summary-status">
    <SummaryStatusIcon :statusIcon="verificationStatusIcon" />
    <SummaryStatusIcon
      :key="status"
      :statusIcon="status"
      v-for="status in summaryStatusData"
    />
  </div>
</template>

<script setup>
import useWatchAndUpdate from "@/composables/helpers/useWatchAndUpdate";
import SummaryStatusIcon from "@/components/layout/summary/SummaryStatusIcon.vue";

const { watchAndTrigger } = useWatchAndUpdate();
const props = defineProps({
  summaryStatusData: {
    type: Object,
  },
});

// verification is always a complete status
const verificationStatusIcon = {
  title: "Verification",
  label: "Completed",
  status: "complete", // cl_core is not "completed"
  color: "#03c5b3",
  icon: "StatusCompleted",
};
</script>

<style lang="scss">
.summary-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
